import { DateTimeFormat } from '../../../formatters/utils/DateTimeFormat'
import { LocaleIdentifier } from '../../../types/localeIdentifier'

export const getDisplayDate = (date: Date | undefined | null, locale: LocaleIdentifier | undefined) => {
  return date ? DateTimeFormat.getFormattedDate(date, locale) : ''
}
